function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Document, Page, pdfjs } from 'react-pdf';
import LoaderWidget from "../../theme/Loader";
import BlankSpace from "../styled/BlankSpace";
const StyledPdfWrapper = styled.div`
  margin: 0 auto;
`;

class PdfViewer extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "state", {
      numPages: null,
      pageNumber: 1
    });

    _defineProperty(this, "onDocumentLoadSuccess", ({
      numPages
    }) => {
      this.setState({
        numPages
      });
    });

    _defineProperty(this, "renderPdf", () => {
      const {
        numPages
      } = this.state;

      if (!!this.props.pdf) {
        return /*#__PURE__*/React.createElement(StyledPdfWrapper, null, /*#__PURE__*/React.createElement(Document, {
          file: this.props.pdf.url,
          onLoadSuccess: this.onDocumentLoadSuccess
        }, Array.from(new Array(numPages), (el, index) => /*#__PURE__*/React.createElement(React.Fragment, {
          key: `page_${index + 1}`
        }, /*#__PURE__*/React.createElement(BlankSpace, {
          rem: 2
        }), /*#__PURE__*/React.createElement(Page, {
          pageNumber: index + 1
        })))));
      }

      return /*#__PURE__*/React.createElement(LoaderWidget, null);
    });

    _defineProperty(this, "render", () => {
      return /*#__PURE__*/React.createElement(React.Fragment, null, this.renderPdf());
    });
  }

  componentDidMount() {
    pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
  }

}

function mapStateToProps(state) {
  return {};
}

export default connect(mapStateToProps, {})(PdfViewer);